/**
 * @typedef {object} FontFamily
 * @property {'HeadlineBlack'} HeadlineBlack - Headline Black font
 * @property {'Roboto'} Roboto - Roboto font
 * @property {'default'} Default - Default font
 */

/** @type {FontFamily} */
export const FontFamily = {
    HeadlineBlack: 'HeadlineBlack',
    Roboto: 'Roboto',
    Default: 'default',
};

/**
 * @typedef {object} FontMetrics
 * @property {number} emSquare - The size of the em square.
 * @property {number} capHeight - The cap height.
 * @property {number} ascender - The ascender height.
 * @property {number} descender - The descender depth.
 */

/**
 * @typedef {object} FontMetricsMap
 * @property {FontMetrics} HeadlineBlack - Metrics for the Headline Black font family.
 * @property {FontMetrics} Roboto - Metrics for the Roboto font family.
 * @property {FontMetrics} Default - Metrics for the default font family.
 */

/**
 * This is the place where the font metric components should be added.
 * You need the Em square (units per em), Cap (capital letter height),
 * ascender (height above baseline) and descender (depth below baseline) height.
 * For extracting font metric components, Capsize can be used:
 * https://seek-oss.github.io/capsize/
 * Font needs to be uploaded there and it reads the values from the font file.
 * The values provided can be used directly here, no conversion needed.
 */

/** @type {FontMetricsMap} */
export const fontMetrics = {
    [FontFamily.HeadlineBlack]: {
        emSquare: 1000,
        capHeight: 700,
        ascender: 962,
        descender: 376,
    },
    [FontFamily.Roboto]: {
        emSquare: 2048,
        capHeight: 1456,
        ascender: 1900,
        descender: 500,
    },
    [FontFamily.Default]: null,
};

fontMetrics[FontFamily.Default] = fontMetrics[FontFamily.HeadlineBlack];
